import React, { useEffect, useState } from 'react';
import { buildingUtilityApi } from '../../api/buildingUtilityApi';
import { BuildingUtilityBooking } from '../../types';
import {
  RegistrationActivityLogsPanel,
  RegistrationActivityLog,
} from '../building-services/RegistrationActivityLogsPanel';

export const UtilityBookingHistoryModal: React.FC<{
  booking: BuildingUtilityBooking;
  onClose: () => void;
}> = ({ booking, onClose }) => {
  const [logs, setLogs] = useState<RegistrationActivityLog[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      try {
        const rows = await buildingUtilityApi.getBookingActivityLogs(booking.id);
        if (!cancelled) setLogs(Array.isArray(rows) ? rows : []);
      } catch {
        if (!cancelled) setLogs([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [booking.id]);

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between border-b px-4 py-3">
          <div>
            <h3 className="font-semibold text-gray-900">Lịch sử thao tác</h3>
            <p className="text-sm text-gray-500">
              {booking.utility?.name} · {booking.apartment?.code}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-xl leading-none px-2"
            aria-label="Đóng"
          >
            ×
          </button>
        </div>
        <div className="overflow-y-auto p-4 pt-2">
          <RegistrationActivityLogsPanel logs={logs} loading={loading} />
        </div>
      </div>
    </div>
  );
};

export default UtilityBookingHistoryModal;
